<template>
    <div class="fcard">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'FCard',
};
</script>

<style lang="scss">
@use "style";
</style>
